import claudiaAPI from 'dashboard/api/claudiaAPI';
import {
  conversationUIFlagsGetter,
  conversationRecordStatusGetter,
  conversationStatusMutations,
  fetchConversationResource,
} from './helpers/claudiaConversationStore';

// Maps the ClaudIA message-groups response into a per-message index so the conversation view can,
// in O(1), decide where the audit trigger goes (the primary bubble) and which bubbles belong to
// the same split response (shared primaryMessageId). Mirrors the claudiaEvents store lifecycle.

const buildIndex = groups => {
  const index = {};
  (groups || []).forEach(group => {
    const messageIds = group.messageIds || [];
    messageIds.forEach(messageId => {
      index[messageId] = Object.freeze({
        primaryMessageId: group.primaryMessageId,
        isPrimary: messageId === group.primaryMessageId,
        hasAudit: group.hasAudit,
        hasHumanAudit: Boolean(group.hasHumanAudit),
      });
    });
  });
  return Object.freeze(index);
};

const state = {
  index: {},
  uiFlags: {},
  recordStatus: {},
};

const getters = {
  // messageId -> { primaryMessageId, isPrimary, hasAudit }. Stable reference between fetches.
  getAuditIndex: _state => conversationUuid => {
    return _state.index[conversationUuid] || {};
  },
  getUIFlags: conversationUIFlagsGetter,
  getRecordStatus: conversationRecordStatusGetter,
};

const mutations = {
  SET_MESSAGE_GROUPS(currentState, { conversationUuid, groups }) {
    currentState.index = {
      ...currentState.index,
      [conversationUuid]: buildIndex(groups),
    };
  },
  ...conversationStatusMutations,
};

const actions = {
  async fetch(context, { conversationUuid, isRefetch = false }) {
    const hasResolvedIndex =
      context.getters.getRecordStatus(conversationUuid) === 'ok';

    await fetchConversationResource(
      context,
      { conversationUuid },
      {
        request: (uuid, store) =>
          claudiaAPI.getConversationMessageGroups(uuid, store),
        onSuccess: (commit, uuid, { groups }) =>
          commit('SET_MESSAGE_GROUPS', { conversationUuid: uuid, groups }),
        preserveOnError: isRefetch && hasResolvedIndex,
      }
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
